import createVueApp from '@/common/createApp'
import sidebar from '@/config/sidebars/mlap'

Styxie.Initializers.MlapSettingsBing = {
  show: async(props) => {
    const { default: BingSettings } = await import('@/vue_widgets/mlap/settings/bing/index.vue')
    createVueApp(BingSettings, { props, sidebar })
  }
}
